/* ============
 * Credit Note Product Module State
 * ============
 */

export default {
  all: [],
};



// WEBPACK FOOTER //
// ./src/app/store/modules/creditNoteProduct/state.js